module.exports = __webpack_public_path__ + "img/se.1f642770.svg";